import { render, staticRenderFns } from "./SimilarListingsKeyword.vue?vue&type=template&id=25967d72&"
import script from "./SimilarListingsKeyword.vue?vue&type=script&lang=js&"
export * from "./SimilarListingsKeyword.vue?vue&type=script&lang=js&"
import style0 from "./SimilarListingsKeyword.vue?vue&type=style&index=0&id=25967d72&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports